import Performacne from './performance';

export default Performacne;



// WEBPACK FOOTER //
// ./src/components/cards/performance/index.js